var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "terms" }, [
    _c(
      "div",
      { staticClass: "terms__wrapper" },
      [
        _c("BaseTitle", {
          staticClass: "terms__title",
          attrs: { text: _vm.titleText, tag: "h1" }
        }),
        _c("BaseCaption", {
          staticClass: "terms__caption  terms__caption--font-big",
          attrs: { text: _vm.captionText, tag: "h2" }
        }),
        _c("div", { ref: "content", staticClass: "terms__content" })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d5c8d198", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5c8d198","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/TermsTextBlock.vue
// module id = RxYH
// module chunks = 7